// @ts-expect-error
/* eslint-disable */
import { request } from '@umijs/max';

/** 12103-新增场馆运营时间版本 POST /web/v1/gymDayly/add */
export async function addDaylyVersion(
  body: API.SwimGymDaylyVersionUpdateReqVO,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOBoolean>('/web/v1/gymDayly/add', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 12105-删除场馆运营时间版本 POST /web/v1/gymDayly/delete/${param0} */
export async function deleteDaylyVersion(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteDaylyVersionParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(`/web/v1/gymDayly/delete/${param0}`, {
    method: 'POST',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 12102-查询场馆运营时间版本详情 GET /web/v1/gymDayly/detail/${param0} */
export async function getDaylyVersionDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getDaylyVersionDetailParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimGymDaylyVersionDetailVo>(
    `/web/v1/gymDayly/detail/${param0}`,
    {
      method: 'GET',
      params: { ...queryParams },
      ...(options || {}),
    },
  );
}

/** 12506-查询场馆生效的运营时间 GET /web/v1/gymDayly/detail/effective */
export async function getEffectiveDaylyVersionDetail(options?: {
  [key: string]: any;
}) {
  return request<API.YmResultVOSwimGymBusinessTimeVo>(
    '/web/v1/gymDayly/detail/effective',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** 12101-分页查询场馆运营时间版本列表 POST /web/v1/gymDayly/pageList */
export async function getDaylyVersionPageList(
  body: API.SwimGymDaylyVersionPageQueryVo,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOYmPageResVOSwimGymDaylyVersionListVo>(
    '/web/v1/gymDayly/pageList',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 12104-修改场馆运营时间版本 POST /web/v1/gymDayly/update */
export async function updateDaylyVersion(
  body: API.SwimGymDaylyVersionUpdateReqVO,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOBoolean>('/web/v1/gymDayly/update', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
